// import { React, useState, useEffect } from "react";
// import { Calendar, Clock } from "lucide-react";
// import axios from "axios";

// const FollowUpHistory = ({ lead_id }) => {
//   const [history, setHistory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const BASE_URL = process.env.REACT_APP_BASE_URL;

//   useEffect(() => {
//     const fetchFollowHistory = async () => {
//       try {
//         const { data } = await axios.post(
//           `${BASE_URL}/leads/getLeadsFollowup`,
//           { lead_id },
//           {
//             headers: { "Content-Type": "application/json" },
//             withCredentials: true,
//           }
//         );
//         console.log("API Response:", data);
//         const followupHistory = Array.isArray(data)
//           ? data
//           : Object.values(data);
//         setHistory(followupHistory);
//       } catch (error) {
//         console.error("Error fetching Follow Up History:", error);
//         setHistory([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchFollowHistory();
//   }, [BASE_URL, lead_id]);

//   if (loading) return <div>Loading...</div>;

//   return (
//     <div className="space-y-6">
//       <h2 className="text-2xl font-semibold">Follow-up History</h2>
//       <div className="space-y-4 max-h-[450px] overflow-y-auto pr-2">
//         {history.map((item) => (
//           <div
//             key={item.id}
//             className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow"
//           >
//             <div className="flex items-start justify-between mb-2">
//               <div className="flex items-center text-gray-600">
//                 <Calendar className="w-4 h-4 mr-2" />
//                 <span className="text-sm">
//                   {new Date(item.followup_date || "").toLocaleDateString()}
//                 </span>
//                 <Clock className="w-4 h-4 ml-4 mr-2" />
//                 <span className="text-sm">
//                   {new Date(item.followup_date || "").toLocaleTimeString()}
//                 </span>
//               </div>
//               <span
//                 className={`px-2 py-1 text-xs rounded-full ${
//                   item?.notes === "completed"
//                     ? "bg-green-100 text-green-800"
//                     : "bg-yellow-100 text-yellow-800"
//                 }`}
//               >
//                 {item?.notes}
//               </span>
//             </div>
//             <h3 className="font-medium text-gray-900 mb-2">{item.action}</h3>
//             <p className="text-gray-600 text-sm">{item.notes}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default FollowUpHistory;
import React, { useState, useEffect } from "react";
import { Calendar, Clock } from "lucide-react";
import axios from "axios";

const FollowUpHistory = ({ lead_id }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchFollowHistory = async () => {
      try {
        const { data } = await axios.post(
          `${BASE_URL}/leads/getLeadsFollowup`,
          { lead_id },
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
        console.log("API Response:", data);
        const followupHistory = Array.isArray(data)
          ? data
          : Object.values(data);
        setHistory(followupHistory);
      } catch (error) {
        console.error("Error fetching Follow Up History:", error);
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFollowHistory();
  }, [BASE_URL, lead_id]);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">Follow-up History</h2>
      <div className="space-y-4 max-h-[450px] overflow-y-auto pr-2">
        {history.map((item) => (
          <div
            key={item.id}
            className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow flex flex-col min-h-[150px]"
          >
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center text-gray-600">
                <Calendar className="w-4 h-4 mr-2" />
                <span className="text-sm">
                  {new Date(item.followup_date || "").toLocaleDateString()}
                </span>
                <Clock className="w-4 h-4 ml-4 mr-2" />
                <span className="text-sm">
                  {new Date(item.followup_date || "").toLocaleTimeString()}
                </span>
              </div>
              <span
                className={`px-2 py-1 text-xs rounded-full ${
                  item?.notes === "completed"
                    ? "bg-green-100 text-green-800"
                    : "bg-yellow-100 text-yellow-800"
                }`}
              >
                {item?.notes}
              </span>
            </div>
            <div className="flex flex-col flex-grow">
              <h3 className="font-medium text-gray-900 mb-2">{item.action}</h3>
              <p className="text-gray-600 text-sm flex-grow">{item.notes}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FollowUpHistory;
